export class UserSignature {
  userSignatureId: number;
  customerId: number;
  userId: string;
  pinNumber: number;
  pinNumberVerified: boolean;
  fileImageString: string;
  active: boolean;
  deactivatePendingDate?: Date | null;
}

export const EMPTY_USERSIGNATURE: UserSignature = {
  userSignatureId: 0,
  customerId: 0,
  userId: '',
  pinNumber: 0,
  pinNumberVerified: false,
  fileImageString: '',
  active: true,
  deactivatePendingDate: null
};
